$(document).ready(function () {

    var alertBoxClose = $('.alert-box__close');

    alertBoxClose.on('click', function () {
        localStorage.setItem("AlertClosed", "true");
        localStorage.setItem("AlertClosedTimeStamp", new Date());
    });

    if (localStorage.getItem("AlertClosedTimeStamp") !== null) {
        var alertBoxClosedTimeStamp = localStorage.getItem("AlertClosedTimeStamp"),
        alertBoxClosedDate = new Date(alertBoxClosedTimeStamp),
        currentDate = new Date(),
        diff = calculateDayDiff(currentDate, alertBoxClosedDate);
        
        // Over 1 dag
        if (diff > 1) {
            localStorage.removeItem("AlertClosed");
            localStorage.removeItem("AlertClosedTimeStamp");
        }
    }

});

function calculateDayDiff(currentDate, timeStampDate) {
    return Math.floor(currentDate - timeStampDate) / (1000 * 60 * 60 * 24);
}